import { PermissionT } from "../types";

export const entCloserGlobal = (permissions: PermissionT[]): boolean => {
  const p = permissions.find((permission) => permission.name === "ent_closer_global");
  return !!p;
};

export default entCloserGlobal;
